export default {
  routes: [
    {
      name: 'bundles',
      path: '/development/bundles',
      component: () => import('./views/TheBundles.vue')
    },
  ]
}
